import Vue from 'vue';
import Vuex from 'vuex';
import Cart from '@/models/Cart/cart';
import apiCheckout from '@/api/checkout';
import ProductPointsList from '@/models/product-points-list';
import GoodiesList from '@/models/goodies-list';
import moduleGoodies from './goodies.js';
import moduleProductSuggestions from './product-suggestions.js';
import moduleAddressBook from '@/store/address-book.js';

Vue.use(Vuex);

export const store = new Vuex.Store({
    strict: true,
    state: {
//        wsCartStatus: false, // false -> error/loading
        isLoading: false,
        showHeader: false,
        navHeaderData: {},
        kStrings: {},
        urls: {},
        cart: new Cart({}),
        pointsData: {},
        pointsProductsList: new ProductPointsList({}),
        // TODO: refactor and put this on "goodies" existent store module
        goodiesProductsList: new GoodiesList({}),
        goodiesData: {},
        goodiePlusCouponModal: false,
        couponOnHold: null,
        toastData: null,
        isAppMode: false,
        isDesktop: false,
        partnerInfo: null,
        cprmLock: false,
        cprmQueue: [],
        error: null,
    },
    mutations: {
        showHeader(state, payload) { // just to test
            state.showHeader = payload;
        },

        showError(state, payload) {
            state.error = payload;
        },

        isLoading(state, payload) { 
            state.isLoading = payload;
        },
        
        goodiePlusCouponModal(state, payload) { 
            state.goodiePlusCouponModal = payload;
        },

        couponOnHold(state, payload) { 
            state.couponOnHold = payload;
        },

        navHeaderData(state, payload) {
            state.navHeaderData = Object.assign({}, state.navHeaderData, payload);
        },

        kStrings(state, payload) {
            state.kStrings = Object.assign({}, state.kStrings, payload);
        },
        
        toastData(state, payload) {
            state.toastData = payload;
        },

        urls(state, payload) {
            state.urls = Object.assign({}, state.urls, payload);
        },

        cart(state, payload) {
            // re-generate cart
            state.cart = new Cart(payload ? payload : {});
            // update list of products points with products already in cart
            if(payload){
                state.pointsProductsList.updateItemsInCart(state.cart.pointsProducts);
                state.goodiesProductsList.updateItemsInCart(state.cart.goodiesProducts);
                if(typeof App != 'undefined' && App.js.checkAppMobile() !== ''){
                    const itemCount = parseInt(state.cart.itemCount);
                    if(!isNaN(itemCount)){
                        App.js.callAppsJs('setCartItem', itemCount);
                    }
                }
            }
        },
        
        pointsData(state, payload) {
            state.pointsData = Object.assign(state.pointsData, payload);
        },

        pointsProductsList(state, payload) {
            // response with all products points does not provide information about products in cart
            // send points product already in cart as second parameter
            state.pointsProductsList.setData(payload, state.cart.pointsProducts);
        },

        goodiesData(state, payload) {
            state.goodiesData = Object.assign(state.goodiesData, payload);
        },
        
        goodiesProductsList(state, payload) {
            // response with all goodies does not provide information about current level or products in cart
            // send additional parameters
            state.goodiesProductsList.setData(payload, state.cart.goodiesInfo.levelIndex, state.cart.goodiesProducts);
        },

        updateSelectedGoodies(state){
            state.goodiesProductsList.updateSelected(state.cart.goodiesProducts);
        },

        coupons(state, payload) {
            state.cart.setCoupons(payload);
        },

        isAppMode(state, payload) {
            state.isAppMode = payload;
        },
        
        isDesktop(state, payload) {
            state.isDesktop = payload;
        },

        partnerInfo(state, payload) {
            state.partnerInfo = payload;
        },
        cprmLock(state, payload) {
            state.cprmLock = payload;
        },
        cprmQueue(state, payload) {
            state.cprmQueue = [...payload];
        },
    },
    actions: {
        setData(context, payload){
            context.commit('cart', payload.cart);
            context.commit('kStrings', payload.i18n);
            context.commit('urls', payload.urls);
            context.commit('isAppMode', payload.isAppMode);
            context.commit('isDesktop', payload.isDesktop);
            context.commit('partnerInfo', payload.hasOwnProperty('partnershipModelsInfo') ? payload.partnershipModelsInfo : null);

            if((payload.cart && payload.cart.hasOwnProperty('showProdSug')) && payload.cart.showProdSug){
                // get product suggestions ()
                try {
                    context.dispatch('getSuggestionProducts');
                } catch (error) {
                    if(typeof Bugsnag !== 'undefined'){
                        Bugsnag.notify('checkout', error, {}, 'error');
                    }
                }
            }
        },

        load(context, payload){
            //console.log('load data', payload);
            context.commit('isLoading', true);
            const callback = response => {
                //console.log('callback ', response);
                if(response.hasOwnProperty(payload.key)){
                    //console.log('callback, commit data', response[payload.key])
                    this.dispatch('setData', response[payload.key]);
                }
            };
            const callbackError = error => {
                //console.log('callbackError ', response);
                //context.commit('error', {error: true, debug: error});
            };
            apiCheckout.load(payload.url, callback, callbackError)
                .then( () => {
                    // always executed
                    context.commit('isLoading', false);
                });
        },

        cartResponse(context, payload) {
            //context.commit('wsCartStatus', true);
            if(payload.hasOwnProperty('cartData')){
                context.commit('cartData', payload.cartData);
            }
            if(payload.hasOwnProperty('navHeaderData')){
                context.commit('navHeaderData', payload.navHeaderData);
            }
            if(payload.hasOwnProperty('kStrings')){
                context.commit('kStrings', payload.kStrings);
            }
            if(payload.hasOwnProperty('promoData')){
                context.commit('promoData', payload.promoData);
            }
        },
        cart(context, payload) {
            //console.log('commit cart', payload);
            context.commit('cart', payload);
        },
        updateQuantity(context, payload){
            // set "loading" state
            context.commit('isLoading', true);
            apiCheckout.updateItemQuantity(payload.cartLineId, payload.quantity).then(response => {
                //console.log('promisse then', response);
                const data = response.data;
                if(data.hasOwnProperty('cart')){
                    //console.log('data.ajaxParams ', data.ajaxParams)
                    // commit new cart data
                    context.commit('cart', data.cart);
                }
                context.commit('isLoading', false);
            });
        },
        removeItem(context, lineId){
            // set "loading" state
            context.commit('isLoading', true);
            apiCheckout.removeItem(lineId).then(response => {
                //console.log('promisse then', response);
                const data = response.data;
                if(data.hasOwnProperty('cart')){
                    // when cart is empty reload page because of short link partner (feature)
                    if(data.cart.itemCount === '0') {
                        location.reload();
                    } else {
                        context.commit('cart', data.cart);
                    }
                    //console.log('data.ajaxParams ', data.ajaxParams)
                    // commit new cart data
                    
                }
                context.commit('isLoading', false);
            });
        },
        removeProductSuggestion(context, sku){
            context.commit('isLoading', true);
            apiCheckout.removeProductSuggestion(sku).then(response => {
                let suggestionProducts = context.getters['productSuggestions/products'].filter(function (e) {
                    return e.sku !== sku.sku;
                });
                context.dispatch('productSuggestions/setProducts', suggestionProducts);
                context.commit('isLoading', false);
            });
        },
        submitCoupon(context, couponCode){
            const isDesktop = context.getters.isDesktop;
            context.commit('isLoading', true);
            
            apiCheckout.submitCoupon(couponCode).then(response => {
                //console.log('promisse then', response);
                const data = response.data;
                //console.log('submitCoupon response', data);
                if(data.hasOwnProperty('checkoutIndex')){
                    //console.log('cart ', data.checkoutIndex.cart);
                    // commit new cart data
                    context.commit('cart', data.checkoutIndex.cart);
                    context.commit('isLoading', false);
                    
                    const couponMsg = data?.checkoutIndex?.cart?.couponMsg ?? null;
                    
                    if(couponMsg) {
                        // normal coupon mode
                        if(couponMsg.errorId != 'CANT_COMBINE_WITH_GOODIES') {
                            let text = couponMsg?.text ?? '';
                            if(text.length){
                                let duration = 6000 + ((text.length - 70) * 50);
                                //if has href link, wait more time
                                if(text.includes('href=')){
                                    duration = duration + 5000;
                                }
                                context.dispatch('loadToast', {
                                    type: couponMsg.valid ? 'success' : 'error',
                                    text: text,
                                    duration: duration < 6000 ? 6000 : duration,
                                });    
                            }
                        } else { // PRE ADDED GOODIE -> APPLY no compatible COUPON
                            context.commit('goodiePlusCouponModal', true);
                        }
                    }
                }else{
                    //fix undefined is not an object (evaluating data.header.success) noibu Issue #3194
                    const success = (data?.header?.success ?? -1);
                    const errors  = data?.header?.error ?? [];
                    const error   = errors.length > 0 ? errors[0] : {};
                    if(success === 0 && (error.id ?? '') === 'LOGIN_REQUIRED'){
                        if(isDesktop){
                            context.commit('isLoading', false);
                            if(typeof accountAuth === 'object'){
                                accountAuth.openLogin();
                            }
                            else{
                                window.location.reload();
                            }
                        }else if(context.getters.urls.login){
                            window.location.href = context.getters.urls.login;
                        }
                    }else{
                        window.location.reload();
                    }
                }
            });
        },
        removeCoupon(context, payload){
            if(context.getters.cprmLock){
                let cps = context.getters.cprmQueue;
                cps.push(payload);
                context.commit('cprmQueue', cps);
                return;
            }
            context.commit('cprmLock', true);
            context.commit('isLoading', true);
            apiCheckout.removeCoupon(payload.lineId, payload.code).then(response => {
                //console.log('promisse then', response);
                const data = response.data;
                if(data.hasOwnProperty('checkoutIndex')){
                    // commit new cart data
                    context.commit('cart', data.checkoutIndex.cart);
                }
                context.commit('cprmLock', false);
                let queue = context.getters.cprmQueue;
                if(queue.length){
                    let p = queue.shift();
                    context.commit('cprmQueue', queue);
                    context.dispatch('removeCoupon',p);
                }else{
                    context.commit('isLoading', false);
                }
            });
        },

        removeCoupons(context, payload){
            context.commit('isLoading', true);
            apiCheckout.removeCoupons().then(response => {
                //console.log('promisse then', response);
                const data = response.data;
                if(data.hasOwnProperty('cart')){
                    // commit new cart data
                    context.commit('cart', data.cart);
                }
                context.commit('isLoading', false);
            });
        },

        updateCouponOffer(context, payload){
            //console.log('updateCouponOffer payload', payload);
            context.commit('isLoading', true);
            apiCheckout.updateCouponOffer(payload.lineId, payload.sku, payload.type).then(response => {
                //console.log('promisse then', response);
                context.commit('coupons', response.data);
                context.commit('isLoading', false);
            });
        },
        
        changeItem(context, payload){
            //console.log('updateCouponOffer payload', payload);
            context.commit('isLoading', true);
            const offer = payload.offer ? payload.offer : 0;
            apiCheckout.changeItem(payload.lineId, payload.sku).then(response => {
                //console.log('promisse then', response);
                const data = response.data;
                if(data.hasOwnProperty('cart')){
                    context.commit('cart', data.cart);
                }
                context.commit('isLoading', false);
            });
        },

        async addToCart(context, payload){
            //console.log('addToCart payload', payload);
            context.commit('isLoading', true);
            const suggested = payload.hasOwnProperty('suggested') && payload.suggested ? '1' : '';
            await apiCheckout.addToCart(payload.sku, payload.quantity, payload.type, suggested).then(response => {
                //console.log('addToCart promisse then', response);
                const data = response.data;
                if(data.hasOwnProperty('cart')){
                    context.commit('cart', data.cart);
                }
                if(data.hasOwnProperty('suggestions')){
                    context.dispatch('productSuggestions/setData', data.suggestions);
                }    
                context.commit('isLoading', false);
                // context.dispatch('loadToast', {
                //     type: 'success',
                //     text: context.state.kStrings.kCART_UPDATE_SUCCESS
                // });

            });
        },

        removeProductPoints(context){
            context.commit('isLoading', true);
            apiCheckout.removeProductPoints().then(response => {
                //console.log('addToCart promisse then', response);
                const data = response.data;
                if(data.hasOwnProperty('cart')){
                    context.commit('cart', data.cart);
                }
                context.commit('isLoading', false);
            });
        },

        getSuggestionProducts(context){
            //context.commit('isLoading', true);
            apiCheckout.getSuggestionProducts().then(response => {
                const data = response.data;
                if(!data.hasOwnProperty('hasError')) {
                    context.dispatch('productSuggestions/setData', data);
                }
                //context.commit('isLoading', false);
            });
        },
        
        updateKStrings(context, payload) {
            //console.log('payload Strings', payload);
            context.commit('kStrings', payload);
        },

        updateActionUrls(context, payload) {
            // TODO: refactor name to "updateUrls"
            context.commit('urls', payload);
        },
    
        goNextStep(context, payload) {
            apiCheckout.nextStepRequest(payload.url, payload.params).catch(e => {
                context.dispatch('showError',e);
            });
        },

        isLoading(context, payload) {
            context.commit('isLoading', payload);
        },

        goodiePlusCouponModal(context, payload) {
            context.commit('goodiePlusCouponModal', payload);
        },

        couponOnHold(context, payload) {
            context.commit('couponOnHold', payload);
        },
        
        isAppMode(context, payload) {
            context.commit('isAppMode', payload);
        },

        isDesktop(context, payload) {
            context.commit('isDesktop', payload);
        },

        showError(context, payload) {
            let message = payload?.message ?? null;
            if(!message){
                return null;
            }
            let error = {
                'context': 'errorCheckout',
                'type' : 'error',
                'text' : message,
            };
            context.commit('showError', error);
            context.commit('isLoading', false);
        },

        loadToast(context, payload) {
            context.commit('toastData', payload)
            // console.log('contexting ',context);
            // console.log('payloading ',payload);
            const eventCouponSubmited = new CustomEvent('couponSubmited', {
                detail: payload,
            });
            document.body?.dispatchEvent(eventCouponSubmited);
            //console.log('show toast: ', payload);
            setTimeout(() => { // after Xs, resets 
                context.commit('toastData', null);
            }, typeof payload.duration !== 'undefined' ? payload.duration : 4000);
            
        },
    },
    getters: {
        isLoading: state => state.isLoading,
        cart: state => state.cart,
        // wsCartStatus: state => state.wsCartStatus,
        showHeader: state => state.showHeader,
        navHeaderData: state => state.navHeaderData,
        kStrings: state => state.kStrings,
        actionUrls: state => state.urls,
        toastData: state => state.toastData,
        urls: state => state.urls,
        isAppMode: state => state.isAppMode,
        isDesktop: state => state.isDesktop,
        pointsData: state => state.pointsData,
        pointsProductsList: state => state.pointsProductsList,
        goodiesData: state => state.goodiesData,
        goodiesProductsList: state => state.goodiesProductsList,
        goodiePlusCouponModal: state => state.goodiePlusCouponModal,
        couponOnHold: state => state.couponOnHold,
        partnerInfo:  state => state.partnerInfo,
        cprmLock: state => state.cprmLock,
        cprmQueue: state => state.cprmQueue,
        error: state => state.error,
    },
    modules: {
        goodies: moduleGoodies,
        productSuggestions: moduleProductSuggestions,
        addressBook: moduleAddressBook,
    }
});
